import { Container } from "@mui/material";
import React from "react";

const HeaderComp = (props) => {
  return (
    <div className="header-body">
      <Container>
        <h1 className="header-title">{props.title}</h1>
      </Container>
    </div>
  );
};

export default HeaderComp;
